import { api, post } from '../../service';

const defaultState = () => ({
    search: {
        size: 10,
        page: 1,
        key: '',
    },
    total: 0,
    sites: [],
});

const install = {
    namespaced: true,
    state: defaultState(),
    actions: {
        clearState({ commit }) {
            commit('clearState');
        },
        async searchSites({ commit, state, rootState }) {
            const params = Object.assign(
                {},
                { ...state.search },
                {
                    agentId: rootState.userInfo.agentId,
                }
            );
            const res = await post(api.site.search, params);
            commit('changeSites', res);
        },
        async enableSite({ dispatch }, data) {
            await post(api.site.enable, data);
            dispatch('searchSites');
        },
        changeSearch({ commit, dispatch }, data) {
            commit('changeSearch', data);
            dispatch('searchSites');
        },
    },
    mutations: {
        clearState(state) {
            Object.assign(state, defaultState());
        },
        changeSites(state, data) {
            state.sites = data.sites;
            state.total = data.totalCount;
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
    },
};

export default install;
